import { AppElement, html } from '../AppElement.js';
import Constants from "../Constants";

const title = 'Housekeeping';
const hotelNamePrefix = 'For';
const text = 'How many rooms can a housekeeper take per shift?';

export default class PersonalHousekeeping extends AppElement {
    static get properties() {
        return {
            // @internalProperty
            value: { attribute: false },
            isLoading: { attribute: false },
        };
    }

    constructor(props = {}) {
        super();
    }

    reflow(props = {}) {}

    getHotelName() {
        return window.infinito.vao.controller.storageHelper.getSelectedHotelName() || Constants.MISSING_STR;
    }

    getVAOSettingKey() {
        return window.infinito.vao.model.vaoSettings.obtainHotelIdHousekeeperPerShiftKey(
            window.infinito.vao.controller.storageHelper.getSelectedHotelId()
        );
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);

        this.isLoading = true;
        window.infinito.vao.model.vaoSettings.fetchSettingByKey(
            window.infinito.vao.controller.storageHelper.getIdentitiesId(),
            this.getVAOSettingKey(),
            (setting) => {
                this.isLoading = false;
                if (!setting || !$.isNumeric(setting.value)) {
                    return;
                }
                this.value = setting.value;
            }
        );
    }

    onCLickSave() {
        if (!$.isNumeric(this.value)) {
            return;
        }
        this.isLoading = true;
        window.infinito.vao.model.vaoSettings.makeSetting(
            window.infinito.vao.controller.storageHelper.getIdentitiesId(),
            this.getVAOSettingKey(),
            this.value,
            () => {
                this.isLoading = false;
            }
        );
    }

    onChangeInput(e) {
        this.value = e.currentTarget.value;
    }

    render() {
        return html`
<div class="vao__components--personalHousekeeping">
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">${title}</h5>
            <h6 class="card-subtitle mb-2 text-muted">${hotelNamePrefix} ${this.getHotelName()}</h6>
            <p class="card-text">${text}</p>
            <div class="input-group">
                <input
                    type="number"
                    class="form-control"
                    min="0"
                    step="1"
                    .value="${this.value}"
                    @change="${this.onChangeInput}"
                >
            </div>
            <br>
            ${this.isLoading 
                ? html`<vao-spinner></vao-spinner>` 
                : html`<vao-button text="Save" @click="${this.onCLickSave}"></vao-button>`
            }
        </div>
    </div>
</div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.PersonalHousekeeping = PersonalHousekeeping;
customElements.define('vao-personal-housekeeping', PersonalHousekeeping);
